"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentLine = void 0;
const common_1 = require("../../common");
const models_1 = require("../../sales-order/models");
const shipment_header_model_1 = require("./shipment-header.model");
const shipping_kit_line_model_1 = require("./shipping-kit-line.model");
class ShipmentLine extends common_1.MongoDocument {
}
exports.ShipmentLine = ShipmentLine;
//# sourceMappingURL=shipment-line.model.js.map